import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import "./Slider.scss";
import axios from "axios";
import { ProductSliderMulti } from "../Components/images/ProductSliderMulti";
import { ProductSliderMultiMob } from "../Components/images/Mob/ProductSliderMulti";
import { useContextData } from "../ApiContext";
import { ensureMediaUrl } from "../utils/mediaUrl";

function queryParamsEqual(a, b) {
  if (!a || !b) return false;
  const toArr = (obj, key) => (Array.isArray(obj?.[key]) ? obj[key].slice().sort() : []);
  return (
    JSON.stringify(toArr(a, "category")) === JSON.stringify(toArr(b, "category")) &&
    JSON.stringify(toArr(a, "subcategory")) === JSON.stringify(toArr(b, "subcategory")) &&
    JSON.stringify(toArr(a, "caseType")) === JSON.stringify(toArr(b, "caseType")) &&
    JSON.stringify(toArr(a, "brand")) === JSON.stringify(toArr(b, "brand")) &&
    JSON.stringify(toArr(a, "color")) === JSON.stringify(toArr(b, "color")) &&
    JSON.stringify(a.price || [0, 10000]) === JSON.stringify(b.price || [0, 10000]) &&
    (a.sort || "popularity") === (b.sort || "popularity")
  );
}

export function Slider({ url, queryParams, queryParamsInit, reset, setReset, setQueryParamsInit }) {
  const location = useLocation();
  const { productListCache, setProductListCache } = useContextData();
  const restoredFromCacheRef = useRef(false);

  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startRef, setStartRef] = useState(false);
  const [page, setPage] = useState(1);
  const [noMoreProducts, setNoMoreProducts] = useState(false);
  const observer = useRef();
  const footerObserver = useRef();
  const footerRef = useRef(null); // Ref for the footer element
  const [footerVisible, setFooterVisible] = useState(false);

  const [orderData, setOrderData] = useState([])

  console.log('queryParams - ', queryParams);


  const fetchProducts = async () => {
    // Empty grid: `.fetch-stopper` can already intersect the viewport — still load page 1.
    // Only skip pagination when the stopper is visible.
    if (footerVisible && page > 1) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await axios.post(
        url || "/products",
        { ...queryParams, page, size: 10 },
        config
      );

      const data = response.data || [];
      const requestedSize = 10;
      if (!data.length || data.length < requestedSize) {
        setNoMoreProducts(true);
      }
      if (data.length) {
        const newSlides = data
          .filter((item) => item.urls && item.urls.length > 0)
          .map((item) => {
            const brandRaw = item.brand;
            const brand =
              Array.isArray(brandRaw) && brandRaw.length
                ? brandRaw[0]
                : brandRaw;
            return {
              id: item._id,
              urls: item.urls.map((url) => ensureMediaUrl(url)),
              title: item.title,
              price: item.price,
              brand,
              mrp: item.mrp,
            };
          });

        setSlides((prevSlides) => {
          const existingIds = new Set(prevSlides.map((s) => String(s.id)));
          const toAppend = newSlides.filter((s) => !existingIds.has(String(s.id)));
          toAppend.forEach((s) => existingIds.add(String(s.id)));
          return toAppend.length ? [...prevSlides, ...toAppend] : prevSlides;
        });
      }

      // const order_response = await axios.post(
      //   `http://localhost:4000/orders/get-all`,
      //   {
      //     filterStatus: [],
      //     filterTime: [],
      //     searchVal: "",
      //     page: 1,
      //     size: 10
      //   },
      //   config
      // );

      // let order_data = order_response.data;
      // console.log('fetchOrder order_response data - ', order_data);

      // if (!order_data.length) {
      //   setNoMoreProducts(true);
      // }

      // setOrderData([...orderData, ...order_data])
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
      setStartRef(true);
    }
  };

  useEffect(() => {
    const restoreScroll = location.state?.restoreScroll;
    const cache = productListCache;
    const cacheMatches =
      cache &&
      cache.pathname === location.pathname &&
      queryParamsEqual(cache.queryParams, queryParams);
    if (
      typeof restoreScroll === "number" &&
      cacheMatches &&
      Array.isArray(cache.slides) &&
      cache.slides.length > 0
    ) {
      restoredFromCacheRef.current = true;
      setSlides(cache.slides);
      setPage(cache.page ?? 1);
      setStartRef(true);
      return;
    }
    // Already restored from cache (effect ran again with new queryParams reference) – don’t clear
    if (typeof restoreScroll === "number" && restoredFromCacheRef.current) {
      return;
    }
    setNoMoreProducts(false);
    setSlides([]);
    setPage(1);
  }, [queryParams]);

  useEffect(() => {
    if (!queryParamsInit) return;
    if (restoredFromCacheRef.current) {
      restoredFromCacheRef.current = false;
      return;
    }
    fetchProducts();
  }, [page, queryParams, queryParamsInit]);

  useEffect(() => {
    if (!queryParamsInit || slides.length === 0) return;
    setProductListCache({
      pathname: location.pathname,
      queryParams: { ...queryParams },
      slides: [...slides],
      page,
    });
  }, [slides, page, queryParams, location.pathname, queryParamsInit]);

  const lastProductRef = useCallback((node) => {
    if (loading || noMoreProducts || footerVisible || !startRef) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setPage((prevPage) => prevPage + 1);
      }
    });

    // if (node) {
    //   observer.current.observe(node);

    //   const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
    //   if (isElementVisible) {
    //     setPage((prevPage) => prevPage + 1);
    //   }
    // }
    if (node) {
      observer.current.observe(node);
      console.log('imtersection - ', node.getBoundingClientRect().top, " - ", window.innerHeight);
      if (node.getBoundingClientRect().top < 0) return
      const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
      if (isElementVisible) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  }, [loading, noMoreProducts, footerVisible, startRef]);

  useEffect(() => {
    if (footerRef.current) {
      footerObserver.current = new IntersectionObserver((entries) => {
        setFooterVisible(entries[0].isIntersecting);
      });

      footerObserver.current.observe(footerRef.current);

      return () => {
        footerObserver.current.disconnect();
      };
    }
  }, []);

  return (
    <div className="slider-flexer">
      {isMobile ? (
        <div className="slider-mob-wrapper">
          <ProductSliderMultiMob slides={slides} isMulti={true} />
          {loading && <div className="loader slider-mob-loader"></div>}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <ProductSliderMulti slides={slides} isMulti={true} />
          {loading && <div className="loader"></div>}
        </div>
      )}
      {isMobile ? (
        <div ref={lastProductRef} className="filter-hider" />
      ) : (
        <div ref={lastProductRef} className="slider-desktop-scroll-sentinel" aria-hidden />
      )}
      {/* Add footer ref */}
      <div ref={footerRef} className="fetch-stopper">
      </div>
    </div>
  );
}
